import Icon from '@ant-design/icons';
import { message } from 'antd';
import classNames from 'classnames';

import CloseSvg from '@/components/Icon/svgs/close.svg';
import ShareSvg from '@/components/Icon/svgs/share.svg';
import { useModel } from '@/hooks/useModel';
import { useTranslation } from '@/i18n/client';
import { EVENT } from '@/utils/event';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';
import { copyToClipboard } from '@/utils/utils';

import styles from './index.less';

interface IProps {
  className?: string;
  onClose?: () => void;
}

function TopBar(props: IProps): JSX.Element | null {
  const { className, onClose } = props;
  const { t } = useTranslation();
  const { userProfile } = useModel('auth-model', (model) => ({ userProfile: model.userProfile }));

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      // 参考 CloseIcon 的实现
      reportClick(EReportClickKey.clicked_hide_screen);
      dispatchEvent(new CustomEvent(EVENT.CHANGE_CHAT_STATUS_LAYOUT, { detail: 'hide' }));
    }
  };

  const handleShare = () => {
    const homeUrl = `${window.location.origin}/${userProfile?.route || ''}`;

    // 参考 SettingModal 的实现
    copyToClipboard(homeUrl).then(() => {
      message.success(
        <span
          dangerouslySetInnerHTML={{
            __html: t('memoryDetail.shareModal.copySuccessTips', {
              url: homeUrl
            })
          }}
        />
      );
    });
  };

  return (
    <div className={classNames(styles.container, className)}>
      {/* 左侧关闭按钮 */}
      <div className={styles.iconButton} onClick={handleClose}>
        <Icon className={styles.icon} component={CloseSvg} />
      </div>

      {/* 中间用户名 */}
      <div className={styles.username}>{userProfile?.name || ''}</div>

      {/* 右侧分享按钮 */}
      <div className={styles.iconButton} onClick={handleShare}>
        <Icon className={styles.icon} component={ShareSvg} />
      </div>
    </div>
  );
}

export default TopBar;
